import React from 'react';
import Lazy from '~co/virtual/lazy';

export default function CollectionPickerIconItems({
  items = [],
  onLink,
  onClose,
}) {
  const onIconClick = (e) => {
    e.preventDefault();
    onLink(e.target.getAttribute('data-link'));
    onClose();
  };

  const renderIcon = ({ png }, index) => (
    <a
      key={index}
      className='ui-icon-picker-icon'
      href=''
      data-link={png}
      onClick={onIconClick}
    >
      <img src={png} loading='lazy' />
    </a>
  );

  const renderTemplate = ({ title, icons = [] }, index) => (
    <div className='mt-[var(--padding-medium)]' key={index}>
      <div className='px-[var(--padding-medium)] opacity-50'>{title}</div>

      <div className='ui-icon-picker-icons'>{icons.map(renderIcon)}</div>
    </div>
  );

  return (
    <div className='ui-icon-picker-wrap'>
      <Lazy
        data={items}
        keyExtractor={({ title }) => title}
        initialNumToRender={1}
      >
        {renderTemplate}
      </Lazy>
    </div>
  );
}
